// External Lib
import { Box, Grid, IconButton } from "@mui/material";
// Internal Lib
import Label from "../../component/Label";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";

const NotificationSidebar = (props: any) => {
  const { notificationList, acknowledgeNotification } = props;

  const acknowledge = (Nid: any) => {
    acknowledgeNotification(Nid);
  };

  return (
    <div className="sidenav-container">
      <div className="single overflow-hidden">
        {notificationList?.map((item: any) => (
          <Grid container className="padding-down-10" spacing={4} key="0">
            <Grid item xs={1} className="flex" style={{ alignItems: "center" }}>
              {/* <IconButton>
                <NotificationsIcon className="label-gray" />
              </IconButton> */}
              <div className="flex">
                <IconButton>
                  <DeleteIcon
                    className="red"
                    onClick={() => {
                      acknowledge(item.id);
                    }}
                  />
                </IconButton>
              </div>
            </Grid>
            <Grid item xs={11} className="border-down">
              <Box pl={3}>
                <div style={{ fontWeight: "bold" }}>
                  {item?.notificationTitle || "-"}
                </div>
                <div style={{ fontSize: "12px", marginBottom: "5px" }}>
                  {item?.notificationTitle ===
                  "Parent Link Generation New Admission" ? (
                    <div>
                      <p className="parent-link-generation-done-notification">
                        {item?.notificationBody?.split(" ")[0]}
                      </p>

                      {" " +
                        item?.notificationBody
                          ?.split(" ")
                          .splice(1)
                          .toString()
                          .replaceAll(",", " ")}
                    </div>
                  ) : (
                    item?.notificationBody?.replace(/<\/?[^>]+(>|$)/g, "") ||
                    "-"
                  )}
                </div>

                <Label
                  view
                  title={moment(item?.createdDate).format("LLL") || "-"}
                />
              </Box>
            </Grid>
          </Grid>
        ))}
      </div>
    </div>
  );
};
export default NotificationSidebar;
